//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import colors from '@/shared/assets/scss/colorsExport.scss';
import observeVisibility from '@/shared/directives/observe-visibility';
import CompareGraph from './Workouts4_CompareGraph.vue';

export default {
  name: 'Workouts4_Compare',
  components: {
    CompareGraph,
  },
  directives: {
    observeVisibility,
  },
  data: () => ({
    colors,
    cyclingCardio: 0,
    cyclingStrength: 0,
    fightcampCardio: 0,
    fightcampStrength: 0,
    bandsCardio: 0,
    bandsStrength: 0,
    blocks: [
      {
        title: 'Cycling / Running',
        cardio: 100,
        strength: 40,
      },
      {
        title: 'FightCamp',
        cardio: 100,
        strength: 100,
        color: colors.accent,
      },
      {
        title: 'Weights / Bands',
        cardio: 20,
        strength: 100,
      },
    ],
  }),
  methods: {
    visibilityChanged(isVisible) {
      if (isVisible) {
        setTimeout(() => {
          this.cyclingCardio = 100;
          this.cyclingStrength = 20;
          this.fightcampCardio = 100;
          this.fightcampStrength = 90;
          this.bandsCardio = 20;
          this.bandsStrength = 100;
        }, 300);
      }
    },
  },

};
